export default __webpack_public_path__ + "static/image046-90b8a1d426363e1b32f7873e5eac8505.gif";